<template>
  <div>
    <center>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
          <v-img
            @click="Home()"
            :lazy-src="require('@/assets/Icon/Back.jpg')"
            max-height="30"
            max-width="100"
            :src="require('@/assets/Icon/Back.jpg')"
          ></v-img>
        </v-card>
      <v-img height="100%" :src="imageQuest"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12">
            <v-card class="rounded-t-xl mt-n15 mx-auto" elevation="12">
              <center>
                <v-card-text>
                  <p class="text-h6 text--primary textHead">
                    โปรดตอบแบบสอบถามต่อไปนี้
                  </p>
                </v-card-text>
                <v-divider class="pa-0 ma-0" color="amber"></v-divider>

                <div>
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >เงื่อนไข</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <h6
                          type="text"
                          class="text-left"
                          v-html="dataItem.masWelfareConditions"
                        ></h6>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >เอกสารประกอบ</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <h6
                          type="text"
                          class="text-left"
                          v-html="dataItem.masWelfareDocument"
                        ></h6>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="font-weight-bold">
                      หัวข้อการอบรม (ชื่อหลักสูตร)
                      <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_topics"
                          color="purple darken-2"
                          :rules="nameRules"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>
                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="font-weight-bold">
                      ชื่อวิทยากรผู้สอน <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_trainer"
                          :rules="nameRules"
                          color="purple darken-2"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>
                <v-row>
                  <v-col>
                    <v-sheet
                      class="mx-auto my-2 rounded-lg text-left"
                      elevation="10"
                      rounded="xl"
                    >
                      <v-sheet
                        class="pa-2 mb-0 amber text-center"
                        dark
                        rounded="t-xl"
                      >
                        <p class="text-h6 text--primary textHead">
                          วันที่เข้ารับการอบรม
                        </p>
                      </v-sheet>
                      <v-card-text class="pa-0 ma-0">
                        <center>
                          <!-- <v-row class="pa-2">
                            <v-col cols="6">
                              <v-card-text class="text-left pb-0">
                                <p class="font-weight-bold">
                                  ตั้งแต่วันที่
                                  <strong class="red--text"> * </strong>
                                </p>
                              </v-card-text>
                              <v-col cols="12">
                                <v-menu
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="form.Training_startDate"
                                      :rules="nameRules"
                                      label="yyyy/dd/mm"
                                      single-line
                                      append-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="form.Training_startDate"
                                    @input="menu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-col>
                            <v-col cols="6">
                              <v-card-text class="text-left pb-0">
                                <p class="font-weight-bold">
                                  ถึงวันที่
                                  <strong class="red--text"> * </strong>
                                </p>
                              </v-card-text>
                              <v-col cols="12">
                                <v-menu
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="form.Training_endDate"
                                      :rules="nameRules"
                                      label="yyyy/dd/mm"
                                      single-line
                                      append-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="form.Training_endDate"
                                    @input="menu2 = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-col>
                          </v-row> -->

                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :return-value.sync="form.Training_startDate"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-combobox
                                  v-model="form.Training_startDate"
                                  @change="calculateStartEndDate()"
                                  multiple
                                  chips
                                  small-chips
                                  label="วันที่เข้าอบรม"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-combobox>
                              </template>
                              <v-date-picker
                                v-model="form.Training_startDate"
                                @change="calculateStartEndDate()"
                                multiple
                                no-title
                                scrollable
                              >
                              <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu3 = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="($refs.menu3.save(form.Training_startDate)), calculateStartEndDate()"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-row class="ml-3 pl-3">
              <v-col cols="7">
                <v-subheader>สรุปจำนวนวันเข้าอบรม</v-subheader>
              </v-col>
              <v-col cols="3">
                <v-text-field
                v-model="form.summaryDay"
                  dense
                  readonly
                  disable
                  suffix="วัน"
                ></v-text-field>
              </v-col>
            </v-row>

                        </center>
                      </v-card-text>
                    </v-sheet>
                  </v-col>
                </v-row>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pb-0">
                    <p class="font-weight-bold">
                      ช่วงเวลาอบรม <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-2 ma-2">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-radio-group
                          class="pt-0 mt-0"
                          v-model="form.Training_duration"
                          :rules="nameRules"
                          column
                          @change="calculateStartEndDate()"
                        >
                          <v-radio label="ช่วงเช้า" value="ช่วงเช้า"></v-radio>
                          <v-radio label="ช่วงบ่าย" value="ช่วงบ่าย"></v-radio>
                          <v-radio label="ทั้งวัน" value="ทั้งวัน"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pb-0">
                    <p class="font-weight-bold">
                      สถานที่อบรม <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-2 ma-2">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-radio-group
                          class="pt-0 mt-0"
                          v-model="form.Training_location"
                          :rules="nameRules"
                          column
                        >
                          <v-radio
                            label="ศูนย์ฝึกอบรมบางชัน"
                            value="ศูนย์ฝึกอบรมบางชัน"
                          ></v-radio>
                          <v-radio
                            label="บริษัท อั๊คโซ่ โนเบล เพ้นท์ส"
                            value="บริษัท อั๊คโซ่ โนเบล เพ้นท์ส"
                          ></v-radio>
                          <v-row class="pa-2">
                            <v-radio label="อื่นๆ:" value="other"></v-radio>
                            <v-text-field v-model="form.Training_other"></v-text-field>
                          </v-row>
                        </v-radio-group>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="font-weight-bold">
                      1.วัตถุประสงค์ หรือ เป้าหมายในเรื่องที่เข้าอบรม
                      <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_objective"
                          :rules="nameRules"
                          color="purple darken-2"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="font-weight-bold">
                      2.สรุปเกี่ยวกับเรื่องที่ท่านเข้าอบรม
                      <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_conclusion"
                          :rules="nameRules"
                          color="purple darken-2"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="font-weight-bold">
                      3.ท่านคิดว่าการอบรมจะมีประโยชน์ต่อการปฏิบัติงานของท่าน
                      และองค์กรของท่านอย่างไร
                      <strong class="red--text"> * </strong>
                    </p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_benefit"
                          :rules="nameRules"
                          color="purple darken-2"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-row>
                  <v-col>
                    <v-sheet
                      class="mx-auto my-2 rounded-lg text-left"
                      elevation="10"
                      rounded="xl"
                    >
                      <v-sheet
                        class="pa-2 mb-0 amber text-center"
                        dark
                        rounded="t-xl"
                      >
                        <p
                          class="
                            text-h6 text--primary text-left
                            pa-2
                            ma-2
                            textHead
                          "
                        >
                          ตารางประเมินองค์กรที่ให้ข้อมูลการฝึกอบรมในครั้งนี้
                        </p>
                      </v-sheet>
                      <v-card-text class="pa-0 ma-0">
                        <center>
                          <v-row class="pa-2">
                            <v-col cols="12">
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr style="background-color: grey">
                                      <th class="text-center"></th>
                                      <th class="text-center">ดีมาก</th>
                                      <th class="text-center">ดี</th>
                                      <th class="text-center">พอใช้</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1. สถานที่จัดฝึกอบรมมีคุณภาพ</td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess1">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess1">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess1">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        2.การให้ข้อมูลด้านความรู้
                                        เสริมทักษะในการไปปฏิบัติงาน
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess2">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess2">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess2">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        3.อุปกรณ์ เครื่องมือ ประกอบการใช้ฝึกอบรม
                                      </td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess3">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess3">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess3">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>4.วิทยากรมีเทคนิคการถ่ายทอดที่ดี</td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess4">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess4">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess4">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        5.วิทยากรสามารถกระตุ้นให้เกิดความสนใจในเนื้อหา
                                      </td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess5">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess5">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess5">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        6.การใช้เวลาเหมาะสมกับเรื่องการฝึกอบรม
                                      </td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess6">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess6">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess6">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        7.ท่านได้รับการเอาใจใส่ในการฝึกอบรมจากศูนย์ฝึกอบรมเป็นอย่างดี
                                      </td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess7">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess7">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess7">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>8.โดยภาพรวมการฝึกอบรมครั้งนี้</td>
                                       <td>
                                        <v-radio-group v-model="form.training_assess8">
                                        <v-radio value="ดีมาก"></v-radio>
                                         </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess8">
                                        <v-radio value="ดี"></v-radio>
                                        </v-radio-group>
                                      </td>
                                      <td>
                                        <v-radio-group v-model="form.training_assess8">
                                        <v-radio value="พอใช้"></v-radio>
                                        </v-radio-group>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                          </v-row>
                        </center>
                      </v-card-text>
                    </v-sheet>
                  </v-col>
                </v-row>

                <v-card
                  class="mx-auto my-2 rounded-lg text-left"
                  elevation="10"
                >
                  <v-card-text class="pr-6 mr-6 pb-0">
                    <p class="text-h6 font-weight-bold">ความคิดเห็นเพิ่มเติม</p>
                  </v-card-text>
                  <v-card-text class="pa-0 ma-0">
                    <center>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          dense
                          v-model="form.Training_comment"
                          color="purple darken-2"
                          required
                        ></v-text-field>
                      </v-col>
                    </center>
                  </v-card-text>
                </v-card>

                <v-row>
                  <v-col cols="12">
                    <v-btn
                      color="amber"
                      block
                      large
                      @click="assessmentUser(form)"
                      >ส่งแบบสอบถาม<v-icon right dark>
                        mdi-clipboard-text
                      </v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </center>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  components: {
    // gmapApi
  },
  name: 'Info',
  data () {
    return {
      center: {},
      date: '',
      menu: false,
      menu2: false,
      menu3: false,
      column: null,
      summaryDay: 1,
      profile: [],
      nameRules: [(v) => !!v || 'กรุณากรอกข้อมูล'],
      form: {
        userLineuserId: ''
      },
      dataReady: true,
      ApplicationKey: '',
      imageQuest: '',
      panel: [0],
      dataItem: []
    }
  },
  async mounted () {
    // Get Line Profile
    this.imageQuest = require('@/assets/Icon/banner_form.png')
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    let date = new Date()
    this.year = moment().format('YYYY')
    this.month = date.getMonth() + 1
    this.day = date.getDate()
    await this.getData()
  },
  methods: {
    async getData () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_welfare_type/getDataTravelExpenses"
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItem = response.data[0]
          console.log('dataItem', this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async calculateStartEndDate () {
      var sumDay = (this.form.Training_startDate).length

      sumDay = this.form.Training_duration === 'ช่วงเช้า' ? sumDay - 0.5 : sumDay
      sumDay = this.form.Training_duration === 'ช่วงบ่าย' ? sumDay - 0.5 : sumDay

      this.form.summaryDay = sumDay
    },
    async assessmentUser (dt) {
      this.dataReady = true
      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.day = this.day !== '' ? this.day : moment().format('D')
      let ds = {
        empCode: this.profile.empCode,
        TrainingCode: 'ค่าเดินทาง',
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        training_year: this.year,
        training_month: this.month,
        training_day: this.day,
        training_date: this.year + '-' + this.month + '-' + this.day,
        Training_topics: dt.Training_topics,
        Training_trainer: dt.Training_trainer,
        Training_startDate: JSON.stringify(dt.Training_startDate),
        Training_duration: dt.Training_duration,
        Training_location: dt.Training_location,
        Training_other: dt.Training_other,
        Training_objective: dt.Training_objective,
        Training_conclusion: dt.Training_conclusion,
        Training_benefit: dt.Training_benefit,
        Training_comment: dt.Training_comment,
        training_assess1: dt.training_assess1,
        training_assess2: dt.training_assess2,
        training_assess3: dt.training_assess3,
        training_assess4: dt.training_assess4,
        training_assess5: dt.training_assess5,
        training_assess6: dt.training_assess6,
        training_assess7: dt.training_assess7,
        training_assess8: dt.training_assess8,
        training_count: dt.summaryDay

      }

      let df = {
        empCode: this.profile.empCode,
        welfare_year: this.year,
        welfare_month: this.month,
        welfare_day: this.day,
        welfare_date: this.year + '-' + this.month + '-' + this.day,
        welfare_status: 'draft',
        welfareRequest: 'สวัสดิการค่าเดินทาง',
        welfareAmount: '200',
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName

      }
      await this.addDataWelfareSubmit(df)
      await this.addDataSubmit(ds)
    },
    async addDataSubmit (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/quest_assessment/add",
          ds
        )
        .then(async (response) => {
          await this.$router.push('/Liff/QuestSuccess')
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataWelfareSubmit (df) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/welfare/add",
          df
        )
        .then(async (response) => {
          this.dataReady = false
          await this.linenotify(df)
          await this.setUpBeforeSendLine(df)
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async linenotify (dt) {
      var massageNoti = 'ขอ' + dt.welfareRequest +
            '\nชื่อพนักงาน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel
      let ds = {
        token: 'ykOxnleuJDAAnR6CwdI98b7PJYidormK5ZdvOApt54Q', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          'type': 'flex',
          'altText': 'ขอสวัสดิการ',
          'contents': {
            'type': 'bubble',
            'header': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'text',
                  'text': 'แจ้งเตือนการร้องขอสวัสดิการ',
                  'offsetBottom': 'none',
                  'offsetTop': 'xs',
                  'weight': 'bold',
                  'position': 'relative',
                  'align': 'start',
                  'wrap': true
                }
              ],
              'offsetBottom': 'md',
              'backgroundColor': '#FFB8A1'
            },
            'body': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'box',
                  'layout': 'horizontal',
                  'contents': [
                    {
                      'type': 'box',
                      'layout': 'vertical',
                      'contents': [
                        {
                          'type': 'image',
                          'url': 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_09/EMP20218193_2022_09_30_16_49_50.png',
                          'size': 'full',
                          'margin': 'lg'
                        }
                      ],
                      'cornerRadius': '100px',
                      'width': '72px',
                      'height': '72px'
                    },
                    {
                      'type': 'box',
                      'layout': 'vertical',
                      'contents': [
                        {
                          'type': 'text',
                          'contents': [
                            {
                              'type': 'span',
                              'text': 'รอตรวจสอบเอกสารและผู้จัดการอนุมัติ',
                              'weight': 'bold',
                              'color': '#000000'
                            },
                            {
                              'type': 'span',
                              'text': '|'
                            }
                          ],
                          'size': 'sm',
                          'wrap': true
                        },
                        {
                          'type': 'text',
                          'text': 'hello, world',
                          'contents': [
                            {
                              'type': 'span',
                              'text': item.welfareRequest,
                              'color': '#D81B60'
                            }
                          ]
                        },
                        {
                          'type': 'text',
                          'text': this.profile.empFull_NameTH
                        }
                      ]
                    }
                  ],
                  'spacing': 'xl',
                  'paddingAll': '20px',
                  'paddingTop': 'xs',
                  'paddingBottom': 'xs'
                },
                {
                  'type': 'separator'
                },
                {
                  'type': 'box',
                  'layout': 'baseline',
                  'contents': [
                    {
                      'type': 'text',
                      'text': 'วันที่ทำรายการ',
                      'flex': 1,
                      'size': 'sm',
                      'color': '#aaaaaa',
                      'align': 'center'
                    },
                    {
                      'type': 'text',
                      'text': item.welfare_date,
                      'size': 'sm',
                      'color': '#666666',
                      'wrap': true,
                      'flex': 1,
                      'align': 'center'
                    }
                  ],
                  'paddingTop': 'md'
                }
              ],
              'paddingAll': '0px',
              'offsetTop': 'xs',
              'spacing': 'none'
            },
            'footer': {
              'type': 'box',
              'layout': 'vertical',
              'contents': [
                {
                  'type': 'button',
                  'action': {
                    'type': 'uri',
                    'label': 'ตรวจสอบสถานะ',
                    'uri': 'line://app/1654154168-JML0KbN5?page=WelfareHistory'
                  },
                  'style': 'primary',
                  'color': '#FFB8A1'
                }
              ]
            }
          }
        }
      ]
      await this.sendLinePush(payload, this.profile.userLineuserId)
      this.dataReady = false
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(
        // eslint-disable-next-line quotes
        this.DNS_IP + "/line/push_message",
        dt,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
    },
    Home () {
      this.$router.push('/Liff/HomeWelfare')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
.textHead {
  font-family: "Kanit";
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/WelfareTravelExpenses.vue